
import { Component, Vue } from "vue-property-decorator";
import {
  NavItem,
  SideBarAction,
  SideBarGetter,
  SideBarMutation
} from "@/components/sidebar/types";
import { AppMenuItemsPos, NavItems } from "@/helpers/constants";
import SpatialNavigation from "spatial-navigation-js";
import { Action, Getter, Mutation } from "vuex-class";
import { Namespace } from "@/store/types";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import { RouteName } from "@/router/types";
import HomeIcon from "@/assets/svg/svg-home/00-home.vue";
import Home from "@/components/homePage/components/Home.vue";
import ChannelsIcon from "@/assets/svg/svg-home/01-channels.vue";
import BuffetIcon from "@/assets/svg/svg-home/02-buffet.vue";
import SettingsIcon from "@/assets/svg/svg-home/07-settings.vue";
import { AppMenuItem, ProviderData } from "@/services/apiService/api.types";
import apiStorageInterface, {
  defaultProviderData
} from "@/services/apiStorageInterface";
import { LocaleSidebarString } from "@/plugins/i18n/types";
import { i18n } from "@/plugins/i18n/vue-i18n-plugin";
import VodIcon from "@/assets/svg/svg-home/03-vod.vue";

@Component({
  components: {
    Home,
    HomeIcon,
    ChannelsIcon,
    BuffetIcon,
    SettingsIcon,
    VodIcon
  }
})
export default class Sidebar extends Vue {
  @Action(SideBarAction.UpdateAppMenuItems, { namespace: Namespace.SideBar })
  updateAppMenuItems!: () => void;

  @Mutation(SideBarMutation.SetSideBarOpen, { namespace: Namespace.SideBar })
  setSideBarOpen!: (sidebarOpenStatus: boolean) => void;

  @Getter(SideBarGetter.GetSideBarOpen, { namespace: Namespace.SideBar })
  getSideBarOpen!: boolean;

  @Getter(SideBarGetter.GetAppMenuItems, { namespace: Namespace.SideBar })
  getAppMenuItems!: AppMenuItem[];

  providerData: ProviderData = defaultProviderData;
  get navItems(): NavItem[] {
    let updatedNavItem = NavItems;

    updatedNavItem.forEach((item) => {
      //for extracting navItem position
      let correspondingAppMenuItem = this.getAppMenuItems.find((obj) => {
        return obj.name === item.name;
      });

      item.position = correspondingAppMenuItem
        ? correspondingAppMenuItem.position
        : 100;

      switch (item.name) {
        case AppMenuItemsPos.Home:
          item.text = i18n.t(LocaleSidebarString.home) as string;

          break;
        case AppMenuItemsPos.Channels:
          item.text = i18n.t(LocaleSidebarString.channels) as string;
          break;
        case AppMenuItemsPos.Buffet:
          item.text = i18n.t(LocaleSidebarString.buffet) as string;
          break;
        case AppMenuItemsPos.Settings:
          item.text = i18n.t(LocaleSidebarString.settings) as string;
          break;
        case AppMenuItemsPos.VoD:
          item.text = i18n.t(LocaleSidebarString.vod) as string;
          break;
      }
    });

    updatedNavItem.sort((a, b) => a.position - b.position);

    return updatedNavItem;
  }

  get logo(): string {
    if (this.providerData.logo) {
      return this.providerData.logo.url;
    }
    return require("/src/assets/images/logo.png");
  }

  get logoCollapsed(): string {
    if (this.providerData.media) {
      return this.providerData.media.url;
    }
    return require("/src/assets/svg/svg-home/plum-logo-colapsed.svg");
  }

  async created(): Promise<void> {
    this.providerData = await apiStorageInterface.fetchProviderData();
    await apiStorageInterface.fetchAppMenuItems();
    this.updateAppMenuItems();
  }

  focusNavItem(): void {
    this.navItems.forEach((item, index) => {
      if (item.routeName === this.$route.name) {
        SpatialNavigation.focus("#" + this.navItems[index].routeName);
        this.setSideBarOpen(true);
      }
    });
  }

  async openPage(routeName: RouteName): Promise<void> {
    if (this.$route.name !== routeName) {
      await this.$router.push({ name: routeName });
      this.focusNavItem();
    }
  }

  navActions(event: KeyboardEvent, navItem: NavItem): void {
    SpatialNavigation.pause();
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_RIGHT:
        // making sure that navigation occurs only after the route has been set
        if (this.$route.name === navItem.routeName) {
          setTimeout(() => {
            SpatialNavigation.focus(navItem.defaultElement);
          });
          this.setSideBarOpen(false);
        }
        break;
    }
    SpatialNavigation.resume();
  }
}
